import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'guide',
  templateUrl: './guide.component.html'
})
export class GuideComponent {

  public title = 'Arvest BPP Text-Styles';

  sampleForm: FormGroup;
  passwordForm: FormGroup;
  radioForm: FormGroup;
  disabledRadioForm: FormGroup;

  firstName = new FormControl('', Validators.required);
  isChecked: boolean = true;
  isSampleFormValid = true;

  email = new FormControl('', [Validators.required, Validators.email]);
  password = new FormControl('', [Validators.required, Validators.minLength(8)]);
  confirmPassword = new FormControl('', [Validators.required, Validators.minLength(8)]);
  viewPassword: boolean = false;
  viewConfirmPassword: boolean = false;
  isPasswordCapsLockOn: boolean = false;
  isConfirmCapsLockOn: boolean = false;
  public hasPasswordFormBeenSubmitted: boolean = false;
  public hasSoiledEmailInput: boolean = false;
  public hasSoiledPasswordInput: boolean = false;
  public hasSoiledConfirmPasswordInput: boolean = false;

  preferredDevice = new FormControl('ios', Validators.required);
  preferredOS = new FormControl('mac', Validators.required);

  years: Array<number> = [2017, 2016, 2015, 2014, 2013, 2012];
  showYears = false;

  accounts: Array<number> = [1003456, 2001464, 2342878, 9800013];
  // selectedAccount = this.accounts[0];

  dialogText = 'Due to inactivity, you will be logged out in 56 seconds. Do you wish to continue your session?';
  confirmText = 'Are you sure you want to delete this account?';
  alertText = 'You do not have access.';
  whatsThisText = 'This is that one thing you know...right?';
  selectList: Array<object> = [
    {
      accountNumber: 123456789,
      address: '1234 Main St',
      selected: true
    },
    {
      accountNumber: 987654321,
      address: '23451 123 St',
      selected: false
    },
    {
      accountNumber: 4567891234,
      address: '4567 Yellow Brick Rd',
      selected: false
    }
  ];

  constructor(fb: FormBuilder, private titleService: Title) {
    this.sampleForm = fb.group({
      firstName: this.firstName
    });

    this.passwordForm = fb.group({
      'email': this.email,
      'passwordGroup': fb.group({
        'password': this.password,
        'confirmPassword': this.confirmPassword
      }, {validator: this.equalValidator})
    });

    this.radioForm = fb.group({
      preferredDevice: this.preferredDevice
    });

    this.disabledRadioForm = fb.group({
      preferredOS: this.preferredOS
    });
  }

  ngOnInit() {
    this.titleService.setTitle('Arvest Business Partner Portal: Guide');
  }

  public equalValidator({value}: FormGroup): { [key: string]: any } {
    const [first, ...rest] = Object.keys(value || {});
    const valid = rest.every(v => value[v] === value[first]);
    return valid ? null : {equal: true};
  }

  public togglePasswordVisibility() {
    this.viewPassword = !this.viewPassword;
  }

  public toggleConfirmPasswordVisibility() {
    this.viewConfirmPassword = !this.viewConfirmPassword;
  }

  public setSelectedYear(year) {
    console.log(year);
  }

  public setSelectedAccount(account) {
    console.log(account);
  }

  public onSampleFormSubmit() {
    if (this.sampleForm.valid) {
      this.isSampleFormValid = true;
    } else {
      this.isSampleFormValid = false;
    }
  }
  public soilEmail() {
    this.hasSoiledEmailInput = true;
  }

  public soilPassword() {
    this.hasSoiledPasswordInput = true;
  }

  public soilConfirmPassword() {
    this.hasSoiledConfirmPasswordInput = true;
  }

  public onPasswordFormSubmit() {
    this.hasPasswordFormBeenSubmitted = true;
    this.hasSoiledEmailInput = false;
    this.hasSoiledPasswordInput = false;
    this.hasSoiledConfirmPasswordInput = false;
  }

  public displayPasswordCapsLockOn($event) {
    this.isPasswordCapsLockOn = $event;
  }

  public displayConfirmCapsLockOn($event) {
    this.isConfirmCapsLockOn = $event;
  }
}
